export { Footer }

import { hintStyle, sepStyle } from './messageStyles.ts'
import { SUPPORT_EMAIL } from '../utils/messages.ts'

// Persistent orientation + a clear support affordance: Vike (home), Docs (the license install
// page), Open Source Pricing, Support. Previously these were reachable only via inline links
// buried in hint text. Rendered on both the dashboard and the sign-in screen.
function Footer() {
  return (
    <footer style={style.footer}>
      <a href="https://vike.dev" style={style.link}>
        Vike
      </a>
      <span style={sepStyle}>·</span>
      <a href="https://vike.dev/license" style={style.link}>
        Docs
      </a>
      <span style={sepStyle}>·</span>
      <a href="https://vike.dev/pricing" style={style.link}>
        Open Source Pricing
      </a>
      <span style={sepStyle}>·</span>
      <a href={`mailto:${SUPPORT_EMAIL}`} style={style.link}>
        Support
      </a>
    </footer>
  )
}

const style = {
  footer: {
    ...hintStyle,
    marginTop: 32,
    paddingTop: 16,
    borderTop: '1px solid #e5e5e5',
    display: 'flex',
    alignItems: 'center',
  },
  link: { color: '#555' },
}
